export default "assets/star-53c90f38.svg";